/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { X as index$H } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import getStorage$1 from './panguMiniApp/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var extendGetStorage = extend({
    panguMiniApp: getStorage$1,
}, index$H);
/**
 * 获取缓存。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * 当没有值时，默认返回空对象{}。因为这里遵循uni-api规范，保持一致。
 * @returns {Promise<unknown>} promise调用结果
 *
 * @example
 * import { getStorage } from '@alife/cn-uni-api';
 *
 * getStorage('your-key').then((res) => {
 *   console.log('success', res);
 * }).catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var getStorage = function (key, params) {
    if (typeof key === 'string') {
        return extendGetStorage(__assign(__assign({}, params), { key: key }));
    }
    return extendGetStorage(key);
};

export { getStorage };
